module.exports = __webpack_public_path__ + "static/media/other.2a7a8216.png";